import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { Configuration } from "../assets/data/config";
import OfflineDb from "../db";
//import { decryptData, encryptData } from "../imon/encryption/AesEnc";

const apiUrl = Configuration.apiService.key; //'https://ovc.imonitorplus.com/service/api/';
const apiSurveyUrl = Configuration.apiSurvey.key;
let header = {};

let basicAuth = localStorage.getItem("basicAuth");

header = {
  "Cache-Control": "no-cache",
  Authorization:
    basicAuth != null
      ? basicAuth
      : "Basic " + btoa("nikhil.gaikwad@duretechnologies.com:Dure@456"), //"Basic UmVhZE9ubHlVc2VyOlRlc3RAMTIz", //'Basic SGVhbHRod29ya2VyQGx0Ymkub3JnOkhlYWx0aHdvcmtlckAxMjM=' //'Basic RGF0YUVudHJ5QHNhdmUuY29tOkRhdGFFbnRyeUAxMjM='
  "Content-Security-Policy": "self",
  "X-Content-Type-Options": "nosniff",
  "X-XSS-Protection": "1; mode=block",
};

/*const instance = axios.create({
    baseURL: apiUrl,
    headers: { 'Content-Type': 'application/json',
                'Cache-Control': 'no-cache'
            }
});

instance.interceptors.request.use(function (config) {
    const token = localStorage.getItem('BasicAuth');
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
},
(error) => Promise.reject(error)
);*/

export const apiServices = {
  apiUrl,
  generateUIC,
  generateRandomNumber,
  registerCaseTEI,
  registerCaseEnrollments,
  loginApi,
  getAPI,
  getBlobAPI,
  postAPI,
  putAPI,
  getAPIFacility,
  postMultiPartFormDataAPI,
  getSurveyAPI,
  postAPIClouinary,
  deleteFromDataStoreAPI,
  deletePatientRecordData,
  //loginEncApi,
};

function generateUIC(entityID) {
  let subURL = `trackedEntityAttributes/${entityID}/generate?-`;

  let url = `${apiUrl}${subURL}`;

  return axios
    .get(url, {
      headers: header,
    })
    .then((response) => {
      return response.data;
    });
}

function generateRandomNumber(param) {
  let subURL = `randomnumber/generate`;

  let url = `${apiUrl}${subURL}`;

  return axios({
    method: "post",
    url: `${apiUrl}${subURL}`,
    headers: header,
    data: param,
  }).then((response) => {
    return response.data;
  });
}

function registerCaseTEI(caseData) {
  let subURL = "trackedEntityInstances";

  return axios({
    method: "post",
    url: `${apiUrl}${subURL}`,
    headers: header,
    withCredentials: true,
    data: caseData,
  });
}

function registerCaseEnrollments(caseData) {
  let subURL = "enrollments";

  return axios({
    method: "post",
    url: `${apiUrl}${subURL}`,
    headers: header,
    withCredentials: true,
    data: caseData,
  });
}
function loginApi(param) {
  let subURL =
    "me?fields=:all,attributeValues[:all,attribute[id,name,displayName]],organisationUnits[id, code],userGroups[id],userCredentials[:all,!user,userRoles[id,name]]";

  return axios({
    method: "GET",
    url: `${apiUrl}${subURL}`,
    headers: { Authorization: param },
    // data: param
  }).then((res) => {
    header = {
      "Cache-Control": "no-cache",
      //Authorization: 'Basic YWRtaW46ZGlzdHJpY3Q=' // admin
      Authorization: param, // NCRHelathworker@covidkaya.org
    };
    return res;
  });
}

// function loginEncApi(username, password, param) {
//   let subURL =
//     "me?fields=:all,attributeValues[:all,attribute[id,name,displayName]],organisationUnits[id,name,displayName],userGroups[id],userCredentials[:all,!user],userRoles[id,name]";
//   let tempHolder = {
//     type: "GET",
//     url: "dhis-web-commons-security/login.action",
//     data: {
//       username: username,
//       password: password,
//     },
//   };
//   const encryptedData = encryptData(tempHolder);
//   return axios({
//     method: "POST",
//     url: `${apiUrl}${"commonencryption/login"}`,
//     headers: { Authorization: param },
//     data: { data: encryptedData },
//     withCredentials: true,
//   }).then((res) => {
//     console.log(decryptData(res.data)["JSESSIONID"]);
//     return axios({
//       method: "get",
//       url: `${apiUrl}${subURL}`,
//       withCredentials: true,
//       headers: {
//         "Content-Type": "application/json",
//         // ...(decryptData(res.data)["JSESSIONID"] ? { 'Cookie': `JSESSIONID=${decryptData(res.data)["JSESSIONID"]}` } : {})
//       },
//     }).then((ress) => {
//       return ress;
//     });
//   });
// }

function getAPI(subURL) {
  return axios({
    method: "GET",
    url: `${apiUrl}${subURL}`,
    withCredentials: true,
    headers: header,
  });
  // return instance.get(subURL)
  // .then(res => res)
  // .catch(reason => Promise.reject(reason));;
  // return axios.get(apiUrl+subURL)
  //   .then(res => res)
  //   .catch(reason => Promise.reject(reason));
}
function getBlobAPI(subURL) {
  return axios({
    method: "GET",
    url: `${apiUrl}${subURL}`,
    headers: header,
    withCredentials: true,
    responseType: "blob",
  });
  // return instance.get(subURL)
  // .then(res => res)
  // .catch(reason => Promise.reject(reason));;
  // return axios.get(apiUrl+subURL)
  //   .then(res => res)
  //   .catch(reason => Promise.reject(reason));
}

function getSurveyAPI(subURL) {
  return axios({
    method: "GET",
    url: `${apiSurveyUrl}${subURL}`,
    withCredentials: true,
    headers: header,
  });
  // return instance.get(subURL)
  // .then(res => res)
  // .catch(reason => Promise.reject(reason));;
  // return axios.get(apiUrl+subURL)
  //   .then(res => res)
  //   .catch(reason => Promise.reject(reason));
}

function getAPIFacility(subURL) {
  return axios({
    method: "GET",
    url: `${apiUrl}${subURL}`,
    withCredentials: true,
    headers: header,
  });
}

function postAPI(subURL, params) {
  return axios({
    method: "POST",
    url: `${apiUrl}${subURL}`,
    headers: header,
    withCredentials: true,
    data: params,
  });
}

function deleteFromDataStoreAPI(subURL, params) {
  return axios({
    method: "DELETE",
    url: `${apiUrl}${subURL}`,
    headers: header,
    withCredentials: true,
    data: {},
  });
}

function deletePatientRecordData(subURL, params) {
  return axios({
    method: "DELETE",
    url: `${apiUrl}${subURL}`,
    headers: header,
    withCredentials: true,
    data: {},
  });
}

function postAPIClouinary(subURL, params) {
  return axios({
    method: "POST",
    url: subURL,
    headers: {
      "Cache-Control": "no-cache",
      Authorization:
        basicAuth != null
          ? basicAuth
          : "Basic RGF0YUNhcHR1cmVVbml0QHByb2R1Y3Qub3JnOkRhdGFDYXB0dXJlVW5pdEAxMjM=", //'Basic SGVhbHRod29ya2VyQGx0Ymkub3JnOkhlYWx0aHdvcmtlckAxMjM=' //'Basic RGF0YUVudHJ5QHNhdmUuY29tOkRhdGFFbnRyeUAxMjM='
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "multipart/form-data",
      "Content-Security-Policy": "self",
      "X-Content-Type-Options": "nosniff",
      "X-XSS-Protection": "1; mode=block",
    },
    data: params,
  });
}

function putAPI(subURL, params) {
  return axios({
    method: "put",
    url: `${apiUrl}${subURL}`,
    headers: header,
    withCredentials: true,
    data: params,
  });
}

function mapStateToProps(state) {
  const { storeState } = state;

  return { userbo: storeState.userBO };
}

function postMultiPartFormDataAPI(subURL, params) {
  return axios({
    method: "POST",
    url: `${apiUrl}${subURL}`,
    //headers: {...header,...{'Content-Type': 'multipart/form-data' }},
    headers: {
      ...header,
      "Cache-Control": "no-cache",
      "Content-Type": "multipart/form-data",
      "Content-Security-Policy": "self",
      "X-Content-Type-Options": "nosniff",
      "X-XSS-Protection": "1; mode=block",
    },
    data: params,
  });
}
// export default connect(mapStateToProps, {setUserDetail, setBasicAuth})(LoginPage);
